<template>
    <div class="floating-text" id="floatingBottomText">
        {{text}} <strong>{{strong}}</strong>
    </div>
</template>

<script>
    export default {
        name: 'BottomFloatingNote',
        props: {
            text: String,
            strong: String
        },
        methods: {
        },
        mounted () {
        },
    }
</script>
